import { ConfirmationModal, useToast } from "@knowtex-ai/components";
import type { McRun } from "../../lib/mc";
import { useCancelMcRun } from "../../hooks/useMcRuns";

interface CancelRunConfirmationProps {
  run: McRun | null;
  onClose: () => void;
}

export default function CancelRunConfirmation({ run, onClose }: CancelRunConfirmationProps) {
  const toast = useToast();
  const cancelRun = useCancelMcRun();

  const confirm = () => {
    if (!run) return;
    cancelRun.mutate(run.id, {
      onSuccess: () => toast.success("Cancel requested", "The worker is stopping; evidence so far is kept."),
      onError: (error) => toast.error("Couldn't cancel the run", error.message),
    });
    onClose();
  };

  return (
    <ConfirmationModal
      open={!!run}
      title="Cancel this MC run?"
      continueText="Cancel run"
      cancelText="Close"
      continueVariant="primary-danger"
      onContinue={confirm}
      onCancel={onClose}
    >
      The worker stops and the run ends as cancelled. Screenshots, recordings and events gathered so far are kept.
    </ConfirmationModal>
  );
}
